import React from 'react'
import { Routes, Route } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import ResourcesPage from '@BUP/pages/Resources'
import TopicDetailPage from '@BUP/pages/Topics/[id]'
import ClassRoomActivitiesPage from '@BUP/pages/Resources/ClassRoomActivitiesPage'

const ResourcesNavigation = () => {
  return (
    <Routes>
      <Route
        path='/'
        element={
          <RoleRoute name='ResourcesPage'>
            <ResourcesPage />
          </RoleRoute>
        }
      />
      <Route
        path='/:roleTag/:tags'
        element={
          <RoleRoute name='TopicDetailPage'>
            <TopicDetailPage />
          </RoleRoute>
        }
      />
      <Route
        path='/:tags'
        element={
          <RoleRoute name='ClassRoomActivitiesPage'>
            <ClassRoomActivitiesPage />
          </RoleRoute>
        }
      />
    </Routes>
  )
}

export default ResourcesNavigation
